export const CELL_DEFAULT_STYLE = {
	paddingLeft: 0, paddingRight: 0, paddingTop: 0, paddingBottom: 0,
};
export const LINK_DEFAULT_STYLE = { display: 'inline-block', marginTop: 10 };
